module.exports = __webpack_public_path__ + "img/GD.471a003b.svg";